import wetvKernel from '@tencent/wetv-kernel';
import { qua, beforeRequest, getAppid } from '../util/util';
const { fetcher } = wetvKernel;
const { videoAppid } = getAppid();
export default {
  GetHomePage: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetHomePage,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  RPCSmartBox: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.RPCSmartBox,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  RPCSearch: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.RPCSearch,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  getDetail: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.getDetail,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetFilterPage: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetFilterPage,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetSearchHotList: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetSearchHotList,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetRPCQueryHistory: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetRPCQueryHistory,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetRPCQueryHistoryUiData: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetRPCQueryHistoryUiData,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  RPCSyncTime: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.RPCSyncTime,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  RPCReportHistory: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.RPCReportHistory,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  RPCReportDelAllHistory: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.RPCReportDelAllHistory,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetQrInfo: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetQrInfo,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  AuthPoll: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.AuthPoll,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  checkAccount: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.checkAccount,
      }),
      body,
      {
        CSRF: true,
        originReturn: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  phoneLogin: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.phoneLogin,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  UserVIPInfo: async (body, params) => (await fetcher.post(
    fetcher.getPbAccessUri({
      path: global.base.UserVIPInfo,
    }),
    body,
    {
      CSRF: true,
      originReturn: true,
      params: {
        ...params,
        'Q-UA': qua(),
        video_appid: videoAppid,
      },
    },
  )),
  Logout: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.Logout,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  ReNew: async (body, params) => (await fetcher.post(
    fetcher.getPbAccessUri({
      path: global.base.ReNew,
    }),
    body,
    {
      CSRF: true,
      params: {
        ...params,
        'Q-UA': qua(),
        video_appid: videoAppid,
      },
    },
  )),
  liveDetail: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.liveDetail,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  liveStreaming: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.liveStreaming,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  liveMultiCamera: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.liveMultiCamera,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  lastPlay: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.lastPlay,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  historyReport: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.historyReport,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  getDetailPage: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.getDetailPage,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  UploadLog: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.UploadLog,
      }),
      body,
      {
        CSRF: true,
        originReturn: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  UserInfoWrite: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.UserInfoWrite,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetUserInfo: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetUserInfo,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  SetUserGrant: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.SetUserGrant,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  CheckChannelAccount: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.CheckChannelAccount,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetLiveDetail: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetLiveDetail,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  LivePoll: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.LivePoll,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
  GetLiveMultiCamera: async (body, params) => {
    beforeRequest();
    return await fetcher.post(
      fetcher.getPbAccessUri({
        path: global.base.GetLiveMultiCamera,
      }),
      body,
      {
        CSRF: true,
        params: {
          ...params,
          'Q-UA': qua(),
          video_appid: videoAppid,
        },
      },
    );
  },
};
